/* Dadés CRO v4.2 – AgencyFlow */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var NL = (document.documentElement.lang || '').toLowerCase().indexOf('nl') === 0;
  var T = NL
    ? { between: 'tussen', and: 'en', locale: 'nl-NL', colour: 'Kleur', save: 'Bespaar', adding: 'Toevoegen…', added: 'Toegevoegd', soldOut: 'Uitverkocht', retry: 'Opnieuw', sizeGuide: 'Maat & pasvorm' }
    : { between: 'between', and: 'and', locale: 'en-GB', colour: 'Colour', save: 'Save', adding: 'Adding…', added: 'Added', soldOut: 'Sold out', retry: 'Try again', sizeGuide: 'Size & fit guide' };

  // 1) Delivery estimate with real dates (working days, Mon–Fri)
  function addWorkingDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    try {
      return d.toLocaleDateString(T.locale, { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) {
      return d.toDateString();
    }
  }
  function initDelivery(scope) {
    (scope || document).querySelectorAll('[data-cro-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-max'), 10) || 5;
      var now = new Date();
      var t = el.querySelector('[data-cro-delivery-text]');
      if (t) t.textContent = T.between + ' ' + fmt(addWorkingDays(now, min)) + ' ' + T.and + ' ' + fmt(addWorkingDays(now, max));
    });
  }

  // 2) Size & fit guide modal (<dialog id="cro-fit">)
  function getFit() {
    return document.getElementById('cro-fit');
  }
  function currentSize() {
    var c = document.querySelector('[id$="__main-product"] variant-radios input[type="radio"]:checked');
    return c && c.value ? c.value.trim() : '';
  }
  function markSize(fit) {
    var size = currentSize();
    fit.querySelectorAll('tr[data-size]').forEach(function (tr) {
      tr.classList.toggle('is-current', !!size && tr.getAttribute('data-size') === size);
    });
  }
  function openFit(trigger) {
    var fit = getFit();
    if (!fit) return;
    initFitModal();
    if (fit.tagName !== 'DIALOG' || typeof fit.showModal !== 'function') {
      // Fallback: old <details> markup or browsers without <dialog>
      fit.open = true;
      fit.setAttribute('open', '');
      if (fit.scrollIntoView) fit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    markSize(fit);
    fit._trigger = trigger || null;
    if (!fit.open) fit.showModal();
    document.documentElement.classList.add('cro-modal-open');
    var body = fit.querySelector('.cro-sizemodal__body');
    if (body) body.scrollTop = 0;
  }
  function initFitModal() {
    var fit = getFit();
    if (!fit || fit.tagName !== 'DIALOG' || fit._croReady) return;
    fit._croReady = true;
    fit.addEventListener('click', function (e) {
      if (e.target === fit) fit.close(); // click on the backdrop
    });
    fit.addEventListener('close', function () {
      document.documentElement.classList.remove('cro-modal-open');
      if (fit._trigger && fit._trigger.focus) fit._trigger.focus();
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var open = e.target.closest('[data-cro-fit-open]');
    if (open) {
      e.preventDefault();
      openFit(open);
      return;
    }
    var close = e.target.closest('[data-cro-fit-close]');
    if (close) {
      e.preventDefault();
      var fit = getFit();
      if (fit && fit.open && fit.close) fit.close();
    }
  });

  // 2c) "Maattabel / Size chart" link next to the size options (top of the buy box)
  var RULER = '<svg class="d-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 16 16 3.5l4.5 4.5L8 20.5z"/><path d="M7.5 12l2 2M10.5 9l2 2M13.5 6l2 2"/></svg>';
  function initSizeLinkTop() {
    if (!getFit()) return;
    var groups = document.querySelectorAll('[id$="__main-product"] variant-radios fieldset, [id$="__main-product"] variant-selects .variant-input-wrapper');
    var target = null;
    for (var i = 0; i < groups.length; i++) {
      var slug = (groups[i].getAttribute('data-option-slug') || '').toLowerCase();
      if (/size|maat/.test(slug)) { target = groups[i]; break; }
    }
    if (!target) return;
    var row = target.querySelector('.form__label');
    if (!row || row.querySelector('.cro-size-link, [data-cro-sizelink]')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cro-size-link';
    btn.setAttribute('data-cro-fit-open', '');
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-controls', 'cro-fit');
    btn.innerHTML = RULER + '<span>' + (NL ? 'Maattabel' : 'Size chart') + '</span>';
    row.appendChild(btn);
  }
  function watchPicker() {
    var main = document.querySelector('[id$="__main-product"]');
    if (!main || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(initSizeLinkTop, 50);
    }).observe(main, { childList: true, subtree: true });
  }

  // 2b) Theme "Size chart" links → open the same modal
  function initSizeChartLink() {
    if (!getFit()) return;
    document.querySelectorAll('a, button').forEach(function (el) {
      if (el.hasAttribute('data-cro-fit-open')) return;
      if (/^\s*(size chart|maattabel|maatgids)\s*$/i.test(el.textContent || '')) {
        var label = Array.prototype.find.call(el.childNodes, function (n) {
          return n.nodeType === 3 && /size chart|maattabel|maatgids/i.test(n.textContent);
        });
        if (label) label.textContent = label.textContent.replace(/size chart|maattabel|maatgids/i, T.sizeGuide);
        else if (el.children.length === 0) el.textContent = T.sizeGuide;
        el.setAttribute('data-cro-sizelink', '');
      }
    });
    document.addEventListener(
      'click',
      function (e) {
        var el = e.target.closest && e.target.closest('[data-cro-sizelink]');
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openFit(el);
      },
      true
    );
  }

  // 3) PDP polish: colour name next to the swatches, readable price + savings
  function initPdp() {
    var pdp = document.querySelector('[data-cro-pdp]');
    if (!pdp) return;
    var active = document.querySelector('[class*="__main-product__item"].is-active');
    var colour = (active && active.getAttribute('aria-label')) || pdp.getAttribute('data-color');
    document.querySelectorAll('[class*="__main-product-title"]').forEach(function (el) {
      if (colour && /select a colou?r|selecteer een kleur|kies een kleur/i.test(el.textContent)) {
        el.innerHTML = T.colour + ': <strong>' + colour.replace(/[<>&]/g, '') + '</strong>';
        el.classList.add('d-colour-label');
      }
    });
    var price = document.querySelector('[id^="Price-"][id$="__main-product"] .price');
    if (price) {
      price.style.removeProperty('margin-top');
      price.classList.add('d-pdp-price');
      price.querySelectorAll('[style]').forEach(function (s) { s.style.removeProperty('font-size'); });
      var save = pdp.getAttribute('data-save');
      if (save && !price.querySelector('.d-save')) {
        var chip = document.createElement('span');
        chip.className = 'd-save';
        chip.textContent = T.save + ' ' + save;
        price.appendChild(chip);
      }
    }
    // Keep "Complete the look" sizes in sync with the size the shopper picks
    var cur = document.querySelector('[id$="__main-product"] variant-radios input[type="radio"]:checked');
    if (cur && cur.value) syncSizes(pdp, cur.value);
    var form = document.querySelector('form[is="product-form"][id^="ProductForm-"]');
    if (form) {
      form.addEventListener('variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        if (v && v.option1) syncSizes(pdp, v.option1);
      });
    }
  }
  function syncSizes(scope, size) {
    scope.querySelectorAll('select[data-d-variant]').forEach(function (sel) {
      Array.prototype.some.call(sel.options, function (o) {
        if (!o.disabled && o.textContent.trim() === size) {
          sel.value = o.value;
          return true;
        }
        return false;
      });
    });
  }

  // 4) One-tap add (PDP "Complete the look" + cart drawer recommendations)
  function quickAdd(btn) {
    var rec = btn.closest('[data-d-rec]');
    var input = rec && rec.querySelector('[data-d-variant]');
    if (!input || !input.value) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = T.adding;

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(input.value, 10), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Could not add');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = data.sections || {};
            if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            var drawer = document.querySelector('cart-drawer');
            if (drawer && !drawer.open && typeof drawer.show === 'function') drawer.show(btn);
            btn.textContent = T.added;
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
          });
      })
      .catch(function (err) {
        btn.textContent = /sold out|not enough|inventory|uitverkocht|niet genoeg/i.test(err.message) ? T.soldOut : T.retry;
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-d-add]');
    if (!btn) return;
    e.preventDefault();
    quickAdd(btn);
  });

  function init() {
    initDelivery();
    initFitModal();
    initSizeChartLink();
    initSizeLinkTop();
    watchPicker();
    initPdp();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initDelivery(e.target); initFitModal(); });
  document.addEventListener('cart:updated', function () { initDelivery(document.querySelector('cart-drawer')); });
})();
